module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dialog/confirm-dialog.component.scss
// module id = ./src/app/shared/dialog/confirm-dialog.component.scss
// module chunks = main